"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Benefits = void 0;
var react_1 = __importDefault(require("react"));
var Benefits_module_scss_1 = __importDefault(require("./Benefits.module.scss"));
var react_redux_1 = require("react-redux");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var react_2 = require("swiper/react");
var Benefits = function (_a) {
    var benefits = _a.benefits;
    var dispatch = (0, react_redux_1.useDispatch)();
    var benefitsElementHandler = function (payload) {
        dispatch((0, modalSlice_1.openModal)('promotion'));
        dispatch((0, modalSlice_1.setPromotionData)(payload));
    };
    var isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
    if (isMobile) {
        return (react_1.default.createElement(react_2.Swiper, { spaceBetween: 12, slidesPerView: 1.6, pagination: false, className: Benefits_module_scss_1.default.benefits_swiper }, benefits.map(function (benefit) { return (react_1.default.createElement(react_2.SwiperSlide, { key: benefit.title, className: Benefits_module_scss_1.default.benefits__slide },
            react_1.default.createElement("div", { className: Benefits_module_scss_1.default.benefits__item, onClick: function () {
                    return benefitsElementHandler({ title: benefit.title, description: benefit.description });
                } }, benefit.title))); })));
    }
    return (react_1.default.createElement("ul", { className: Benefits_module_scss_1.default.benefits }, benefits.map(function (benefit) { return (react_1.default.createElement("li", { className: Benefits_module_scss_1.default.benefits__item, onClick: function () {
            return benefitsElementHandler({ title: benefit.title, description: benefit.description });
        }, key: benefit.title }, benefit.title)); })));
};
exports.Benefits = Benefits;
